// extracted by mini-css-extract-plugin
export default {"mainDiv":"SliderBox_mainDiv__Q1uFC","link":"SliderBox_link__d2961","title":"SliderBox_title__ybVW7"};